import { render, staticRenderFns } from "./card-holder.vue?vue&type=template&id=6e434432"
import script from "./card-holder.ts?vue&type=script&lang=ts&external"
export * from "./card-holder.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports